import { createRequiredContext } from '@klokhuis/utilities/RequiredContext';

import { IAppServices } from './types';

export const AppServicesContext =
  createRequiredContext<IAppServices>('AppServicesContext');
